import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Input, message } from "antd";
import { put, get, post} from "../../../services/authService";
import "./styles.scss";

const ForgetPasswordCode = () => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleVerify = async () => {
    setLoading(true);
    try {
      const response = await post("/api/Account/confirmCode", {
        email,
        code,
        changeOrForgotPasswordConfirmation: true,
      });

      setLoading(false);
      message.success("Code verified!");
      navigate("/newPassword", { state: { email } });
    } catch (error) {
      setLoading(false);
      message.error("Invalid code!");
    }
  };

  const handleResendCode = async () => {
    try {
      const response = await post("/api/Account/resendCode", {
        email,
      });

      message.success("Verification code resent!");
    } catch (error) {
      message.error("Failed to resend code.");
    }
  };

  return (
    <div className="wrapper">
      <div className="row">
        <div className="col-md-6 left-column">
          <img
            src="/assets/svg/LoginImage.svg"
            alt="Login Visual"
            className="leftImage"
          />
        </div>

        <div className="col-md-6 right-column">
          <div className="form-wrapper1">
            <h2 className="verificationCodeHeader">Verification Code</h2>
            <p className="verificationCodeText">
              Please enter the verification code that we sent to {email}
            </p>
            <form>
              <Input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter code"
                className="code-input"
              />

              <div className="buttonsModal">
                <Button
                  className="addButtonTPM"
                  key="submit"
                  type="primary"
                  onClick={handleVerify}
                  loading={loading}
                  disabled={loading}
                >
                  Verify code
                </Button>
              </div>
            </form>
            {/* Resend code link */}
            <p className="verificationCodeText">
              If you didn’t receive a verification code,{" "}
              <span
                style={{ color: "#E164A0", cursor: "pointer" }}
                onClick={handleResendCode}
              >
                click here to resend it
              </span>{" "}
              or send us an email at info@kaptechgroup.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordCode;
